/**
 * Compatibility layer for existing imports.
 * The webpack entry point is main.js. Scenes import the Phaser config and
 * shared gameState from here.
 */
import getConfig from '@config/baseConfig';

const config = getConfig();

const gameState = {
  level: 1,
};

export { config, gameState };
